import React from 'react'
import './style.css';

const FooterComponent = () => {
    return (
        <footer>
            <div className='footer'>
                <div className='footer__Container'>
                    <span>Yacdany Arguedas Mora</span>
                </div>
            </div>
        </footer>
    )
}

export default FooterComponent